import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    moreInfo: {
        id: "promo.moreInfo",
    },
    h2: {
        id: "promoModal.h2",
    },
    p: {
        id: "promoModal.p",
    },
    action: {
        id: "promoModal.action",
    },
    trusty: {
        id: "promoModal.trusty",
    },
});

export default messages;
